import { render, staticRenderFns } from "./excel-to-json.vue?vue&type=template&id=15013e00&scoped=true"
import script from "./excel-to-json.vue?vue&type=script&lang=js"
export * from "./excel-to-json.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15013e00",
  null
  
)

export default component.exports